import { render } from "./TimeCustom.vue?vue&type=template&id=84c1225e&scoped=true"
import script from "./TimeCustom.vue?vue&type=script&lang=js"
export * from "./TimeCustom.vue?vue&type=script&lang=js"

import "./TimeCustom.vue?vue&type=style&index=0&id=84c1225e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c1225e"]])

export default __exports__